export const levels = [
    { code: 'E', label: 'Easy' },
    { code: 'M', label: 'Medium' },
    { code: 'C', label: 'Complex' },
];